// extracted by mini-css-extract-plugin
export default {"carouseldiv":"Item_carouseldiv__Bsnv7","carouselimg":"Item_carouselimg__ySwP4","ItemDIV":"Item_ItemDIV__j8x5g"};